
import { recipeIngredientsStore } from '@/store/RecipeIngredientsStore';
import useRightPath from '~/composables/useRightPath';
import usePreventHandlingEmptyLink from '~/composables/usePreventHandlingEmptyLink';
import AzImg from '~/components/Atoms/AzImg.vue';

export default {
  name: 'IngredientsList',
  components: {
    AzImg,
  },
  props: {
    activeTab: {
      type: String,
    },
    allIngredients: {
      type: Array,
      default: () => [],
    },
  },
  setup(_props) {
    const store = recipeIngredientsStore;
    const { getProductPath } = useRightPath();

    const findQuantity = (currentIngredient) => {
      if (currentIngredient.quantities) {
        return store.findQuantity(currentIngredient.quantities);
      } else {
        return [currentIngredient.quantity];
      }
    };

    const getIngredientName = (ingredient) => {
      if (ingredient.name) {
        return ingredient.name;
      }
      const title = ingredient?.nonPurchasableIngredient?.fields?.title;

      return title || '';
    };

    const addPlusIfSecondAndAfter = (str, index) => {
      if (!str) return '';

      const stringWithoutPlus = str.replace(/\+/g, '');
      if (!index) return stringWithoutPlus;
      return `+ ${stringWithoutPlus}`;
    };

    const getIngredientImage = (ingredient) => {
      if (ingredient.image) {
        return ingredient.image;
      }
      const url = ingredient.nonPurchasableIngredient?.fields?.image?.fields?.file?.url;

      return url;
    };

    const getLink = (ingredient) => {
      const { slug, isEssentialOil } = ingredient;

      return slug ? getProductPath({ slug, isEssentialOil }) : '';
    };

    return {
      getLink,
      getIngredientName,
      getIngredientImage,
      findQuantity,
      addPlusIfSecondAndAfter,
      usePreventHandlingEmptyLink,
    };
  },
};
